import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ConcessionScreen from './pages/ConcessionScreen';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:token" element={<ConcessionScreen />} />
        {/* Optional: catch all invalid routes */}
        <Route path="*" element={<div>404 Not Found</div>} />
      </Routes>
    </Router>
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
  );
}

export default App;
